export default [
    {
        name: 'rut',
        props: {
            label: 'Rut',
        },
        type: 'rut-field',
        value: '',
    },
    {
        name: 'business_name',
        props: {
            label: 'Razón Social',
        },
        type: 'text-field',
        value: '',
    },
    {
        name: 'alias_name',
        props: {
            label: 'Nombre',
        },
        type: 'text-field',
        value: '',
    },
]
